import React from "react";
import {
  enhanced_benefits_container,
  enhanced_benefits_intro,
  enhanced_benefits,
  enhanced_benefit_container,
  image,
  image_container,
  button_container,
  content_container,
} from "./EnhancedBenefits.module.scss";
import playRightArrow from "../../images/icons/stepRightArrow.svg";
import parse from "html-react-parser";
import { Button } from "../Button/Button";
import { navigate } from "gatsby";

interface EnhancedBenefitsPropTypes {
  enhancedBenefitsData: {
    benefits: {
      Title: string;
      Copy: string;
      Icon: {
        alternativeText: string;
        localFile: {
          publicURL: string;
          childImageSharp: null;
        };
      };
    }[];
    intro: string;
    cta: {
      link: string;
      text: string;
      icon: {
        localFile: {
          publicURL: string;
        };
      };
    };
  };
  buttonClick: () => {};
}
const EnhancedBenefits = ({
  enhancedBenefitsData: { benefits, intro, cta },
  buttonClick,
}: EnhancedBenefitsPropTypes) => {
  return (
    <div className={enhanced_benefits_container}>
      <div className={enhanced_benefits_intro}>{parse(intro)}</div>
      <div className={enhanced_benefits}>
        {benefits.map(({ Title, Copy, Icon }, index) => {
          return (
            <div key={index} className={enhanced_benefit_container}>
              <div className={image_container}>
                <div className={image}>
                  <img src={Icon.localFile.publicURL} alt="" />
                </div>
                {benefits.length !== index + 1 ? (
                  <img src={playRightArrow} alt="step arrow right" />
                ) : null}
              </div>
              <div className={content_container}>
                <p>Step {index + 1}</p>
                <p>{Title}</p>
                <p>{parse(Copy)}</p>
              </div>
            </div>
          );
        })}
      </div>
      <div className={button_container}>
        <Button
          label={cta.text}
          bkgColor="blackOnLight"
          icon={cta.icon.localFile.publicURL}
          handleOnClick={buttonClick}
          type="internalLink"
        />
      </div>
    </div>
  );
};

export default EnhancedBenefits;
